<div class="vertical-list-container" [class.expandable]="expandable && !isExpanded" [class.has-border]="hasBorder">
  <div class="vertical-list-timeline">
    <div class="inner-container" [class.compact]="!!compact" [class.mx-0]="!isCenterAlign">
      <div class="header-row row" *ngIf="isHeaderVisible">
        <div class="header-title category-field col-1 ms-1" style="display: flex; justify-content: start">{{
          'campaign_milestone_category' | translate
        }}</div>
        <div class="header-title p-0 status-field col-2" style="right: 14px">{{
          'campaign_milestone_status' | translate
        }}</div>
        <div
          class="header-title milestone-field col-2 ps-3"
          [class.stretch]="isMilestoneColumnStretch"
          style="right: 54px"
          >{{ 'campaign_milestone_milestone_name' | translate }}</div
        >
        <div class="header-title drive-date-field col-1" style="right: 42px">{{
          'milestoneStatusEditor_dueDate' | translate
        }}</div>
        <div class="header-title drive-date-field col-2" style="left: 14px">{{
          'milestoneStatusEditor_actualDate' | translate
        }}</div>
      </div>
      <ng-container *ngFor="let category of timeline">
        <ng-container *ngFor="let milestone of category?.items">
          <div
            *ngIf="!milestone.items?.length"
            class="milestone-row"
            [ngClass]="{ 'disabled-milestone': milestone.activeMilestone === false }">
            <div
              class="category-field category"
              [style.background]="milestone.blockColor"
              [class.gate-milestone]="gateMilestoneNames.includes(milestone.name)"
              >{{ category.name }}
            </div>
            <div class="border-top d-flex align-items-center ms-2 py-2 values-container row">
              <div class="status-field status col-1">
                <mtm-status-flag-milestone
                  [isTransparentBg]="false"
                  class="flag-wrapper"
                  [status]="milestone.status"
                  [flagWidth]="18"
                  [flagHeight]="18"></mtm-status-flag-milestone>
              </div>
              <div class="milestone-field col-3" [class.stretch]="isMilestoneColumnStretch">
                <span class="milestone-name">{{ milestone.name }}</span>
              </div>
              <div
                class="drive-date-field drive-date pe-1 w-auto col-2 p-0"
                (click)="$event.stopPropagation(); onDateClick(milestone)">
                <span *ngIf="milestone?.driveDate != null">{{ getFormattedDate(milestone.driveDate) | ngbDate }}</span>
                <img
                  *ngIf="canEdit && milestone?.driveDate != null"
                  src="/assets/img/project-v2/calendar-black.svg"
                  width="12"
                  height="10"
                  class="calendar-icon" />
                <span *ngIf="milestone?.driveDate == null">NA</span>
              </div>
              <div
                class="drive-date-field drive-date ps-1 w-auto col-3 p-0"
                style="justify-content: flex-start"
                (click)="$event.stopPropagation(); onDateClick(milestone)">
                <span *ngIf="milestone?.actualDate != null">{{
                  getFormattedDate(milestone.actualDate) | ngbDate
                }}</span>
                <img
                  *ngIf="canEdit && milestone?.actualDate != null"
                  src="/assets/img/project-v2/calendar-black.svg"
                  width="12"
                  height="10"
                  class="calendar-icon" />
                <span *ngIf="milestone?.actualDate == null">NA</span>
              </div>
            </div>
          </div>
          <ng-container *ngIf="milestone.items?.length">
            <div
              *ngFor="let subItem of milestone.items"
              class="milestone-row subitem-row"
              [class.has-border]="hasBorder"
              [ngClass]="{ 'disabled-milestone': subItem.activeMilestone === false }">
              <div
                class="category-field"
                [style.background]="milestone.blockColor"
                [class.gate-milestone]="gateMilestoneNames.includes(milestone.name)"
                >{{ category.name }}
              </div>
              <div class="border-top d-flex align-items-center ms-2 py-2 values-container row">
                <div class="status-field col-1">
                  <mtm-status-flag-milestone
                    [isTransparentBg]="false"
                    class="flag-wrapper"
                    [status]="subItem.status"
                    [flagWidth]="18"
                    [flagHeight]="18"></mtm-status-flag-milestone>
                </div>
                <div
                  class="milestone-field d-flex flex-column align-items-start gap-2 col-3"
                  [class.stretch]="isMilestoneColumnStretch">
                  <span class="subitem-name">{{ subItem.name }}</span>
                  <span class="milestone-name">{{ milestone.name }}</span>
                </div>
                <div
                  class="drive-date-field drive-date w-auto p-0 col-2"
                  (click)="$event.stopPropagation(); onDateClick(subItem)">
                  <span *ngIf="subItem?.driveDate != null">{{ getFormattedDate(subItem.driveDate) | ngbDate }}</span>
                  <img
                    *ngIf="canEdit && subItem?.driveDate != null"
                    src="/assets/img/project-v2/calendar-black.svg"
                    width="12"
                    height="10"
                    class="calendar-icon" />
                  <span *ngIf="subItem?.driveDate == null">NA</span>
                </div>
                <div
                  class="drive-date-field drive-date col-3 p-0 w-auto"
                  style="justify-content: start"
                  (click)="$event.stopPropagation(); onDateClick(subItem)">
                  <span *ngIf="subItem?.actualDate != null">{{ getFormattedDate(subItem.actualDate) | ngbDate }}</span>
                  <img
                    *ngIf="canEdit && subItem?.actualDate != null"
                    src="/assets/img/project-v2/calendar-black.svg"
                    width="12"
                    height="10"
                    class="calendar-icon" />
                  <span *ngIf="subItem?.actualDate == null" class="ps-1">NA</span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="expander" *ngIf="expandable && !isExpanded">
    <div class="transparent"></div>
    <button class="btn d-flex justify-content-center align-items-center btn-expand" (click)="toggleHeightLimit()">
      <i class="fa fa-chevron-down"></i>
    </button>
  </div>
</div>
